export const DBA_REGISTRIES_RESET_STATE = 'DBA_REGISTRIES_RESET_STATE';
export const DBA_REGISTRIES_CURRENT_ITEM = 'DBA_REGISTRIES_CURRENT_ITEM';

export const DBA_REGISTRIES_REQUEST_LOADING = 'DBA_REGISTRIES_REQUEST_LOADING';
export const DBA_REGISTRIES_REQUEST_SUCCESS = 'DBA_REGISTRIES_REQUEST_SUCCESS';
export const DBA_REGISTRIES_REQUEST_FAILED = 'DBA_REGISTRIES_REQUEST_FAILED';

export const DBA_REGISTRIES_CURRENT_ACTION = 'DBA_REGISTRIES_CURRENT_ACTION';
export const DBA_REGISTRIES_RESET_ACTION = 'DBA_REGISTRIES_RESET_ACTION';